var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00021 3.32998C9.19021 3.32998 9.38021 3.39998 9.53021 3.54998L16.0502 10.07C17.1102 11.13 17.1102 12.87 16.0502 13.93L9.53021 20.45C9.24021 20.74 8.76021 20.74 8.47021 20.45C8.18021 20.16 8.18021 19.68 8.47021 19.39L14.9902 12.87C15.4702 12.39 15.4702 11.61 14.9902 11.13L8.47021 4.60998C8.18021 4.31998 8.18021 3.83998 8.47021 3.54998C8.62021 3.40998 8.81021 3.32998 9.00021 3.32998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.d67d8558aceb3a765926a61f01af97f4.svg";
export { ForwardRef as ReactComponent };